<template>
  <div class="card">
    <div class="card__up">
      <div class="card__up-case">
        <div class="card__up-case-img" @click="onOpenDetail">
          <picture v-if="data.images.length != 0">
            <source :srcset="'https://akshop.a-dev.xyz' + data.images[0]" />
            <img :src="'https://akshop.a-dev.xyz' + data.images[0]" :alt="data.name" loading="eager" />
          </picture>
          <picture v-else>
            <source srcset="@/assets/image/empty.webp" />
            <img
              src="@/assets/image/empty.jpg"
              alt="Нет фото"
              loading="eager"
            />
          </picture>
        </div>
        <div v-if="false" class="card__up-case-info">
          <div class="card__up-case-info-value">В наличии: 18 шт</div>
          <div class="card__up-case-info-text">399.99 ₽/кг</div>
        </div>
        <div class="card__up-case-text" @click="onOpenDetail">
          {{ data.name }}
        </div>
      </div>
    </div>
    <div class="card__down">
      <div class="card__down-prices">
        <div class="card__down-price-old" v-if="false">109.90 ₽ /шт</div>
        <div class="card__down-price-new">
          {{ priceFormat(data.basePrice) }}
          <div
            v-if="data.measure == 'кг' && false"
            class="card__down-price-tag"
          >
            1 кг
          </div>
        </div>
      </div>
      <div class="animation-btn">
        <ChangeBasket :source="data" />
      </div>
    </div>
  </div>
  <SwipeModal
    v-if="isVisible"
    ref="bottomSheetRef"
    @onCloseDetail="onCloseDetail"
  >
    <CardDetail :data="data" />
  </SwipeModal>
</template>
<script setup lang="ts">
  import { onMounted, onUnmounted, PropType, ref } from "vue";
  import ChangeBasket from "./ChangeBasket.vue";
  import SwipeModal from "./SwipeModal.vue";
  import CardDetail from "./CardDetail.vue";
  import { priceFormat } from "@/helpers/priceFormat";
  import { eventBus } from "@/helpers/eventBus";
  import { IProduct } from "@/models/models";

  const props = defineProps({
    data: {
      type: Object as PropType<IProduct> | null,
      required: true,
    },
  });
  
  const bottomSheetRef = ref<InstanceType<typeof SwipeModal>>();

  const isVisible = ref(false);

  const onOpenDetail = () => {
    isVisible.value = true;
    setTimeout(() => {
      bottomSheetRef.value?.open();
    }, 200);
  };

  const onCloseDetail = () => {
    isVisible.value = false;
  };
</script>
<style scoped lang="scss">
  .card {
    border-radius: 8px;
    background: $white;
    box-shadow: 2px 4px 16px 0px rgba(92, 92, 92, 0.08);
    padding: 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &__up {
      &-case {
        position: relative;

        &-icons {
          position: absolute;
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;

          &-like {
            opacity: 0;
            stroke: #25472f;
            fill: none;
            z-index: 1;
            width: 48px;
            height: 48px;
            position: absolute;
            right: 0px;
            top: 0px;

            transition: all 0.3s ease-in-out;

            svg {
              width: 24px;
              height: 24px;
            }

            &--active {
              opacity: 1;

              svg {
                fill: #ff7997;
                stroke: none;
              }
            }
          }
        }

        &-img {
          display: flex;
          justify-content: center;
          height: 137px;
          //   padding-top: 16px;
          margin-bottom: 12px;

          img {
            height: 100%;
          }
        }

        &-info {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          margin-bottom: 8px;
          justify-content: space-between;

          &-text {
            color: $darkGray;
            font-family: $FFCircle;
            font-size: 10px;
            font-weight: 400;
            line-height: 12px;
          }

          &-value {
            color: $darkGray;
            font-family: $FFCircle;
            font-size: 10px;
            line-height: 12px;
            font-weight: 400;
            margin-right: 8px;
          }
        }

        &-text {
          margin-bottom: 12px;
          color: $almostBlack;
          font-family: $FFCircle;
          font-size: 12px;
          line-height: 16px;
          font-weight: 400;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      }
    }

    &__down {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: end;
      min-height: 36px;

      &-price {
        &-old {
          font-family: $FFCircle;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          text-decoration: line-through;
        }

        &-new {
          display: flex;
          gap: 8px;
          align-items: center;
          color: $darkGreen;
          font-family: $FFCircle;
          font-size: 14px;
          font-weight: 700;
          line-height: 20px;
        }

        &-tag {
          font-family: $FFCircle;
          padding: 0 4px;
          background-color: $lightGreen;
          border-radius: 4px;
          font-weight: 700;
          font-size: 12px;
          line-height: 20px;
          color: $darkGreen;
        }
      }
    }

    @include mediumMobile {
      padding: 8px;
    }
  }
</style>
